<template>
  <section
    class="p-5 bg-card border border-border rounded-ds-lg shadow-ds-sm"
  >
    <header
      class="flex items-start justify-between gap-3.5"
      :class="$slots.fields || $slots.default ? 'mb-4' : undefined"
    >
      <div class="flex gap-3 flex-1 min-w-0">
        <span
          class="inline-flex items-center justify-center size-9 shrink-0 rounded-ds-md"
          :class="tone === 'brand' ? 'bg-accent text-accent-foreground' : 'bg-secondary text-muted-foreground'"
        >
          <component
            :is="icon"
            class="size-4.5"
          />
        </span>
        <div class="flex-1 min-w-0">
          <slot name="heading" />
        </div>
      </div>
    </header>

    <slot />

    <!--
      Deliberately NOT a grid. WizardFields owns the field layout and brings its
      own, so gridding here nested one inside the other: the outer grid placed
      the whole inner grid into a single 1fr track, the inner grid then split
      that third into thirds, and every field came out ~120px wide with the
      labels overlapping. One owner of the layout, and it is WizardFields.
    -->
    <slot name="fields" />
  </section>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  /** Brand plate for the asset, neutral for the liability — as drawn. */
  tone?: 'brand' | 'neutral'
  /** The transaction this record actually creates, e.g. 'add position'. */
  transactionType?: string
}>()
</script>
